import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyMobileBar from "@/components/StickyMobileBar";
import api from "@/lib/api";

const CATS = ["All", "Criminal Law", "Civil Law", "Supreme Court", "Bombay High Court", "Legal Updates"];

export default function Insights() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    document.title = "Legal Insights | Nexus Legal";
    const q = cat === "All" ? "" : `?category=${encodeURIComponent(cat)}`;
    api.get(`/articles${q}`).then((r) => setArticles(r.data)).catch(() => {});
  }, [cat]);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Nav />
      <section className="pt-40 md:pt-56 pb-24 px-6 md:px-24 max-w-[1600px] mx-auto">
        <div className="chapter-num mb-6">The Notes</div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.05] text-white/95 mb-12">Legal<br/><span className="italic text-[#C8A45D]/90">Insights.</span></h1>
        <div className="hairline w-24 mb-12" />

        <div className="flex flex-wrap gap-2 md:gap-4 mb-16">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`cat-${c.toLowerCase().replace(/\s/g,'-')}`}
              className={`px-4 py-2 font-cinzel text-[10px] tracking-[0.3em] border transition-all ${cat===c ? "border-[#C8A45D] text-[#C8A45D]" : "border-white/10 text-white/50 hover:border-white/30 hover:text-white/80"}`}
            >{c.toUpperCase()}</button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {articles.map((a, i) => (
            <motion.article key={a.id} initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{duration:0.7, delay: (i%3)*0.06}}>
              <Link to={`/insights/${a.slug}`} className="group block">
                <div className="relative overflow-hidden aspect-[4/3] mb-6 bg-white/[0.02]">
                  {a.thumbnail && <img src={a.thumbnail} alt={a.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 group-hover:scale-105" onError={(e)=>{e.target.style.display="none";}}/>}
                  <div className="absolute inset-0 border border-white/5 group-hover:border-[#C8A45D]/30 transition-colors duration-500"/>
                </div>
                <div className="flex justify-between items-center mb-3 text-[10px] font-cinzel tracking-[0.3em]">
                  <span className="text-[#C8A45D]">{a.category}</span>
                  <span className="text-white/40">{a.reading_time}</span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-white/95 leading-tight group-hover:text-[#C8A45D] transition-colors duration-500">{a.title}</h3>
                <p className="mt-4 text-white/50 font-body text-sm line-clamp-2">{a.excerpt}</p>
                <div className="mt-4 text-[10px] font-cinzel tracking-[0.3em] text-white/30">{new Date(a.created_at).toLocaleDateString(undefined,{year:"numeric", month:"short", day:"numeric"})}</div>
              </Link>
            </motion.article>
          ))}
          {articles.length===0 && <div className="col-span-full text-white/40 font-cinzel text-xs tracking-[0.3em]">NO ARTICLES</div>}
        </div>
      </section>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
